import clamp from './clamp';

export default function exponentialDelayFactory({
	initialDelay = 500,
	maxDelay = 5000,
	multiplier = 1.33,
	// Seed the factory from disk if needed
	startingAttemptCount = 0,
	// Jitter: random variance to prevent thundering herd.
	// 0.25 = subtract 0-25% from computed delay, spreading reconnections over time.
	// Google SRE standard for avoiding synchronized retries.
	jitter = 0.25,
} = {}) {
	let attempt = startingAttemptCount;
	const generator = () => {
		attempt += 1;
		// Compute base delay with exponential backoff
		const baseDelay = clamp(
			initialDelay * multiplier ** (attempt - 1),
			initialDelay,
			maxDelay,
		);

		// Apply jitter: subtract a random 0-jitter% from the base delay.
		// This spreads reconnections over time - e.g., with jitter=0.25 and baseDelay=1500ms,
		// actual delay will be between 1125ms-1500ms (random).
		const jitterAmount = jitter > 0 ? baseDelay * Math.random() * jitter : 0;
		const delay = Math.floor(baseDelay - jitterAmount);

		// console.warn(`exponentialDelayFactory: attempt=${attempt}, baseDelay=${baseDelay}, jitter=${jitterAmount}, delay=${delay}`);
		return delay;
	};

	generator.reset = () => {
		attempt = 0;
	};

	generator.reduce = () => {
		attempt = Math.max(0, attempt - 1);
	};

	generator.attempts = () => attempt;

	return generator;
}
